import { AfterViewInit, ComponentRef, Directive, ElementRef, EventEmitter, Output, ViewChild, ViewContainerRef } from "@angular/core";

@Directive()
export abstract class FgbBaseModal implements AfterViewInit{
    childComponentRef?: ComponentRef<any>;
    @ViewChild('modal', { static: true }) modal!: ElementRef<HTMLDivElement>;
    @ViewChild('container', { read: ViewContainerRef, static: true }) private container!: ViewContainerRef;
    @Output() closed = new EventEmitter<void>();

    abstract open (): void;
    abstract close(fn: () => void): void;
    
    insertComponent<T>(compRef: ComponentRef<T>){
        if( !this.container ) return;
        this.container.insert(compRef.hostView);
        this.childComponentRef = compRef;
    }

    ngAfterViewInit(): void {
        this.open();
    }
}